const when = (hours = 0) => new Date(Date.now() - hours * 3600000).toISOString();

export const demoSupportTickets = [
  { id: 'demo-support-1', username: 'mira.noir', subject: 'Frage zur Auszahlung', status: 'open', createdAt: when(4), updatedAt: when(2), messages: [
    { id: 'demo-message-1', role: 'user', body: 'Wann kann ich eine Auszahlung anfordern?', createdAt: when(4) },
    { id: 'demo-message-2', role: 'admin', body: 'Im Testbereich siehst du hier die Antwort des Supports.', createdAt: when(2) }
  ] },
  { id: 'demo-support-2', username: 'noah.afterhours', subject: 'Profilbild ändern', status: 'closed', createdAt: when(28), updatedAt: when(24), messages: [
    { id: 'demo-message-3', role: 'user', body: 'Wie ändere ich mein Profilbild?', createdAt: when(28) },
    { id: 'demo-message-4', role: 'admin', body: 'Öffne dein Profil und wähle „Profil bearbeiten“.', createdAt: when(24) }
  ] },
  { id: 'demo-support-3', username: 'alexw', subject: 'Hilfe zum Gruppenchat', status: 'open', createdAt: when(3), updatedAt: when(3), messages: [
    { id: 'demo-message-5', role: 'user', body: 'Wie verwalte ich die Mitglieder meiner Gruppe?', createdAt: when(3) }
  ] }
];

export function demoAdminDashboard(state, tickets = demoSupportTickets) {
  const users = [state.me, ...state.creators.slice(0, 5)].map((person, index) => ({
    id: person.id, name: person.name, username: person.username, city: person.city || 'Köln',
    createdAt: when(24 * (30 + index)), lastSeenAt: when(index), status: 'active',
    identityStatus: 'verified', complianceStatus: index % 2 ? 'submitted' : 'approved',
    isAdmin: index === 0, walletCents: index ? 4200 + index * 1300 : state.me.walletCents,
    bonusWalletCents: index ? 0 : state.me.bonusWalletCents, payoutCents: index ? 2600 + index * 500 : 4200,
    payoutPendingCents: 500, payoutReserveCents: 300, creatorSharePercent: 70,
    posts: index ? 2 + index : state.posts.filter((post) => post.mine).length,
    stories: index % 3, subscriptions: index * 2, creator: true, private: false,
    spentCents: index * 1200
  }));
  const posts = state.posts.slice(0, 8).map((post, index) => ({
    id: post.id, username: post.author.username, text: post.text, accessMode: post.accessMode,
    priceCents: post.priceCents || 0, likes: post.likes || 0, comments: post.comments || 0,
    moderationStatus: index === 0 ? 'pending' : 'approved', moderationReason: '', media: []
  }));
  const stories = state.stories.slice(0, 8).map((story, index) => ({
    id: story.id, username: story.username || state.me.username, text: story.text || '',
    moderationStatus: story.moderationStatus || (index === 0 ? 'pending' : 'approved'),
    moderationReason: story.moderationReason || '', hasAudio: Boolean(story.hasAudio || story.musicUrl),
    createdAt: story.createdAt || when(1), expiresAt: story.expiresAt || when(-23)
  }));
  return {
    demoData: true,
    metrics: { users: users.length, verified: users.length, creators: users.length - 1,
      suspended: 0, active24h: 4, posts: state.posts.length, activeStories: state.stories.length,
      messages: state.chats.reduce((sum, chat) => sum + chat.messages.length, 0), groups: state.groups.length,
      openReports: 1, openSupportTickets: tickets.filter((ticket) => ticket.status === 'open').length,
      pendingPosts: 1, pendingStories: stories.filter((story) => story.moderationStatus === 'pending').length,
      pendingModeration: 1 + stories.filter((story) => story.moderationStatus === 'pending').length,
      pendingPayouts: 1, pendingCompliance: 1,
      grossVolumeCents: 46200, contentGrossCents: 18300, contentSales: 7,
      bonusSpentCents: 800, creatorPayoutCents: 12250, adminShareCents: 5250,
      topupOrders: 2, topupGrossCents: 30000, creatorPendingCents: 2100,
      creatorReserveCents: 800 },
    users,
    transactions: [
      { username: 'mira.noir', kind: 'wallet_topup', amountCents: 10000, createdAt: when(3) },
      { username: 'alexw', kind: 'post_unlock', amountCents: -699, createdAt: when(5) }
    ],
    contentSales: [
      { sourceKind: 'post_unlock', buyer: 'alexw', creator: 'mira.noir', createdAt: when(5),
        grossCents: 699, eligibleCents: 699, bonusCents: 0, creatorCents: 489, creatorPercent: 70, adminCents: 210 }
    ],
    paymentOrders: [
      { id: 'demo-topup-1', username: 'alexw', referenceCode: 'DEMO-1001', provider: 'sepa_manual',
        amountCents: 10000, creditCents: 10000, status: 'submitted', createdAt: when(6),
        submittedAt: when(5), payerNote: 'TESTDATEN' },
      { id: 'demo-topup-2', username: 'mira.noir', referenceCode: 'DEMO-1002', provider: 'sepa_manual',
        amountCents: 20000, creditCents: 20000, status: 'paid', createdAt: when(30),
        submittedAt: when(29), providerTransactionId: 'DEMO-BANK-1' }
    ],
    payoutRequests: [
      { id: 'demo-payout-1', username: 'mira.noir', amountCents: 5000, method: 'SEPA',
        accountName: 'Demo Creator', iban: 'DE00 TESTDATEN', status: 'requested', requestedAt: when(9) }
    ],
    complianceQueue: [
      { userId: users[1]?.id || 'demo-user', name: users[1]?.name || 'Mira Hoffmann',
        username: users[1]?.username || 'mira.noir', status: 'submitted', livenessStatus: 'pending',
        taxStatus: 'pending', payoutStatus: 'pending', explicitContentDeclared: true, agreementAccepted: true }
    ],
    participantQueue: [
      { id: 'demo-participant-1', displayName: 'Demo Mitwirkende', username: 'mira.noir',
        status: 'pending', hasProviderReference: true, hasConsentReference: true }
    ],
    reports: [
      { id: 'demo-report-1', reporter: 'alexw', target: 'mira.noir', reason: 'TESTDATEN – Beispielmeldung',
        status: 'open', createdAt: when(2) }
    ],
    supportTickets: tickets.map(({ messages, ...ticket }) => ticket),
    posts, stories,
    settings: { registration_enabled: 'true', support_email: 'support@example.test',
      maintenance_message: 'TESTDATEN – keine echte Plattformkonfiguration', platform_fee_percent: '30' },
    audit: [
      { action: 'demo.preview', admin: 'admin', target: 'testbereich', createdAt: when(1) }
    ]
  };
}
